// extracted by mini-css-extract-plugin
export default {"flag":"Card_flag__5P-bL","card":"Card_card__-SwHU","titulo":"Card_titulo__thYBR","continente":"Card_continente__yqIiC"};